import React, { useState } from 'react';
import qs from 'qs';
import { BoundedContent, Button, Link, Typography } from '@vp/swan';
import { LOCALIZED_ROUTES } from 'src/constants';
import { useAuth } from 'src/hooks/useAuth';

const naBookletsQueryParams = {
  key: 'PRD-G6UZIHNM',
  productVersion: 12,
  selectedOptions: JSON.stringify({ Size: '5.5" x 8.5"', Pages: '12p (cover + 8 inside)' }),
  qty: 1,
};

const naRollLabelsQueryParams = {
  key: 'PRD-DF5PWTHC',
  productVersion: 25,
  selectedOptions: JSON.stringify({ 'Product Orientation': 'Horizontal', Shape: 'Rounded Rectangle', Size: '1"x2"' }),
  qty: 1,
};

const euBookletsQueryParams = {
  key: 'PRD-ESGJ2KYHR',
  productVersion: 12,
  selectedOptions: JSON.stringify({ Size: 'A5 Portrait', 'Page Count (Including cover)': '8' }),
  qty: 1,
};

const auBookletsQueryParams = {
  key: 'PRD-IXE5AFARM',
  productVersion: 3,
  selectedOptions: JSON.stringify({ Size: 'A5', 'Number of Pages': '8pp' }),
  qty: 1,
};

const vistaCreatePostersQueryParams = {
  key: 'PRD-HSKBMXYA',
  productVersion: 19,
  selectedOptions: JSON.stringify({
    Lamination: 'No',
    'Product Orientation': 'Vertical',
    Size: '16" X 20"',
    Substrates: 'Semi-Gloss',
  }),
  qty: 1,
  editUrl: 'https://create.vista.com/team/projects/6233918a4aee996cedb42ad1/',
  createdBy: 'VistaCreate',
};

const flyersQueryParams = {
  key: 'PRD-F2EJ5DIT',
  productVersion: 14,
  selectedOptions: JSON.stringify({
    Size: '5" x 7"',
    'Product Orientation': 'Vertical',
    'Paper Stock': 'Matte',
    'Paper Thickness': 'Standard',
    Backside: 'Color',
  }),
  qty: 25,
};

function buildUrl(culture: string, queryParams: { [key: string]: unknown }) {
  const translatedUrls = LOCALIZED_ROUTES[culture.toLowerCase()];
  console.log(translatedUrls);
  return `${translatedUrls}?${qs.stringify({ ...queryParams, culture })}`;
}

export const DevLandingPage: React.FC = () => {
  const [filePath, setFilePath] = useState('');
  const { vpAuth } = useAuth();

  return (
    <BoundedContent>
      <Typography component="h1" fontSize={'x2large'}>
        Design Services Upload and Print Page
      </Typography>
      {vpAuth &&
        (vpAuth.isSignedIn() ? (
          <Button size="mini" onClick={() => vpAuth.signOut()}>
            Sign out
          </Button>
        ) : (
          <Button size="mini" onClick={() => vpAuth.signIn()}>
            Sign in
          </Button>
        ))}
      <div>
        <Link href={buildUrl('en-US', naBookletsQueryParams)}>en-US booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('en-CA', naBookletsQueryParams)}>en-CA booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('es-US', naBookletsQueryParams)}>es-US booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('en-IE', euBookletsQueryParams)}>en-IE booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('fr-FR', euBookletsQueryParams)}>fr-FR booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('en-AU', auBookletsQueryParams)}>en-AU booklets</Link>
      </div>
      <div>
        <Link href={buildUrl('en-US', flyersQueryParams)}>en-US flyers</Link>
      </div>
      <div>
        <Link href={buildUrl('fr-CA', flyersQueryParams)}>fr-CA flyers</Link>
      </div>
      <div>
        <Link href={buildUrl('en-US', naRollLabelsQueryParams)}>en-US roll labels</Link>
      </div>
      <div>
        <Link
          href={buildUrl('en-US', {
            ...vistaCreatePostersQueryParams,
            fileUri: filePath ? `https://create.vista.com${filePath}` : '',
          })}
        >
          VistaCreate en-US posters
        </Link>{' '}
        File path: <input value={filePath} onChange={e => setFilePath(e.target.value)} />
      </div>
    </BoundedContent>
  );
};
